import {GetDiscountsResponse_Discount_PriceReductionCampaign} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/target_group.types';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useDiscounts} from './useDiscounts';

type PriceReductionCampaign = {
  priceReductionCampaign: GetDiscountsResponse_Discount_PriceReductionCampaign;
};

export const useShowCampaignPhonePopup = () => {
  const {data: discountData} = useDiscounts();
  const {targetGroup} = useSelectedTargetGroup();

  return discountData?.discounts.some(discount => {
    const isPxCampaign = discount.discount?.$case === 'priceReductionCampaign';

    if (!isPxCampaign) return false;

    if (targetGroup === TargetGroup.FEMALE) {
      return (discount.discount as PriceReductionCampaign)
        .priceReductionCampaign.femaleTopBanner.showAppStoreLinkCta;
    } else {
      return (discount.discount as PriceReductionCampaign)
        .priceReductionCampaign.maleTopBanner.showAppStoreLinkCta;
    }
  });
};
